import React from 'react';
import _ from 'lodash';

export const AuthContext = React.createContext({
    auth: {
        isAuthenticated: false,
        errorCode: undefined,
        errorMessage: undefined,
    },
    setAuth: _.noop,
});
